const defaultErrorHandler = (e) => {
  throw e
}

export default function copyToClipboard(text, action = () => {}, errorHandler = defaultErrorHandler) {
  navigator.clipboard.writeText(text)
    .then(action)
    .catch(errorHandler)
}

export function replaceHtmlWithData(selector, data) {
  const caption = $(selector).html()
  $(selector).html($(selector).data(data))
  $(selector).data(data, caption)
}

export function copyToClipboardWithAnimation(selector, text) {
  if (!$(selector).hasClass('active')) {
    replaceHtmlWithData(selector, 'content')
    $(selector).addClass('active')
    setTimeout(() => {
      replaceHtmlWithData(selector, 'content')
      $(selector).removeClass('active')
    }, 1500)
    copyToClipboard(text)
  }
}

export function bindClickToCopyAttr(selector, attrName) {
  if (!$(selector).length) {
    return false
  }

  $(selector).on('click', () => {
    copyToClipboardWithAnimation(selector, $(selector).attr(attrName))
  })

  return false
}
